import React, { useEffect, useState } from 'react';
import { generateToken } from '../../utility/Token';
import SampleVideoPlayer from './SampleVideoPlayer/SampleVideoPlayer';
import './SampleVideos.css';
import closeImg from '../../images/actions/close.svg';

interface SampleVideosProps { index: number; setIsSampleVideosEnabled: React.Dispatch<React.SetStateAction<boolean>>; }



const SampleVideos: React.FC<SampleVideosProps> = ({ index, setIsSampleVideosEnabled }) => {

    const [loading, setLoading] = useState(true);
    const [sampleVideosData, setSampleVideosData] = useState<any[]>([]);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [videoList, setVideoList] = useState<File[]>([]);

    const isMobileDevice = /Mobi/i.test(navigator.userAgent);
    const isValidIndex = index >= 0 && index < sampleVideosData.length;

    const userToken = generateToken("9876543210", "1231234561");
    const headers = { 'Accept': 'application/json', 'Content-Type': 'application/json', 'token': userToken };

    const sampleVideoTitleBase = isMobileDevice ? "คลิปตัวอย่างการสอน" : "คลิปตัวอย่างการสอน – ";
    const sampleVideoTitleName = (isValidIndex && !isMobileDevice) ? sampleVideosData[index]?.name : "";
    const sampleVideoTitle = sampleVideoTitleBase + sampleVideoTitleName;



    const handleCloseButtonClick = () => { setShowConfirmationModal(true); };

    const handleCloseConfirmed = () => { setShowConfirmationModal(false); setIsSampleVideosEnabled(false); };

    const handleCloseCanceled = () => { setShowConfirmationModal(false); };

    const getSampleVideos = async () => {
        try {
            setLoading(true);
            const url = `${process.env.REACT_APP_API_URL_V2}/v1/video/samples`;
            const response = await fetch(url, { method: 'GET', headers });
            if (!response.ok) throw new Error(response.statusText);
            setSampleVideosData((await response.json()).data);
        } catch (error) {
            console.error("Error fetching sample videos:", error);
        } finally {
            setLoading(false);
        }
    };

    const getVimeo = async (index: number) => {
        try {
            if (!sampleVideosData[index]) return;
            const headers = { 'Authorization': `Bearer ${process.env.REACT_APP_VIMEO_AUTH}`, 'Content-Type': 'application/json' }
            const res = await fetch(`https://api.vimeo.com/videos/${sampleVideosData[index].url_id}`, { headers });
            if (!res.ok) throw new Error(res.statusText);
            setVideoList((await res.json()).files);
        } catch (error) {
            console.error("Error fetching Vimeo videos:", error);
        }
    };



    useEffect(() => { getSampleVideos(); }, []);

    useEffect(() => { if (isValidIndex) getVimeo(index); }, [index, sampleVideosData]);



    if (loading) return <div>กำลังโหลดวิดีโอตัวอย่าง...</div>;

    return (
        <>
            {isValidIndex && (
                <>
                    <div className="wraper" id="sampleVideoWrapper" />
                    <div className="sample-video-bg">
                        <div className="sample-video-modal">

                            {showConfirmationModal && (
                                <div className="sample-video-confirmation-modal">
                                    <p>คุณกำลังจะออกจากหน้าตัวอย่างคลิปการสอน{isMobileDevice && <span> ดำเนินการต่อ?</span>}</p>
                                    {isMobileDevice ? null : <p>ดำเนินการต่อ?</p>}
                                    <div className="sample-video-confirmation-modal-buttons">
                                        <button onClick={handleCloseConfirmed}>ตกลง</button>
                                        <button onClick={handleCloseCanceled}>ยกเลิก</button>
                                    </div>
                                </div>
                            )}

                            <img className="sample-video-close-button can-click" src={closeImg} alt="Close Button" onClick={handleCloseButtonClick} />

                            <h1 className="sample-video-title">{sampleVideoTitle}</h1>
                            {isMobileDevice && isValidIndex && (
                                <h2 className="sample-video-title">{sampleVideosData[index]?.name}</h2>
                            )}

                            <div className="sample-video-container">
                                <SampleVideoPlayer fileList={videoList} />
                            </div>

                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default SampleVideos;
